import { SeeqNames } from '@seeqdev/constants';

export const ContextDataType = SeeqNames.SeeqContextNameSpace.DataTypes;
export type ContextDataType = (typeof ContextDataType)[keyof typeof ContextDataType];

export const ContextOperationType = SeeqNames.SeeqContextNameSpace.Operations;
export type ContextOperationType = (typeof ContextOperationType)[keyof typeof ContextOperationType];

export interface ContextMessage {
  itemId: string;
  datumId?: string;
  contextType: ContextDataType;
  operationType: ContextOperationType;
  linkedItems: string[];
}

export interface ContextSchema {
  id: string;
  conditionId: string;
  itemId: string;
  kind: string;
  kindId: string;
  userSeeqId: string;
  userMetadata: any;
  timeCreated: Date;
  timeUpdated: Date;
  eventStart?: Date | null;
  eventEnd?: Date | null;
  identifier: string;
  content: ContextContent;
  isPinned?: boolean;
  purview: any;
  timeDeleted?: Date | null;
  seeqUser: string;
  messageTime: Date;
  datumId?: string;
  duplicates?: number;
  deletionIds?: string[];
  extensionContexts?: StagedContext[];
  conditionMonitorId?: string;
  labelName?: string;
  category?: string;
  archived?: boolean;
  sourceContextEventStart?: Date | null;
  sourceContextEventEnd?: Date | null;
}

export type ContextContentValue = string | boolean | number;

export type ContextContent = {
  value: ContextContentValue; // This is a value for the context.  For example, true or false in the case of something that has a binary state.  Must be in the allowable values of the context characteristics.
  payload?: any; // This is an arbitrary payload that the extension can use to store any data it wants (i.e. for suppression this would contain the expiration date, etc.)
  reasonCodePath?: string[];
};

type StagedContextIdentifier = {
  identifier: string; // This identifies the extension (i.e. flag, label, review, etc.)
};

interface ReasonCodeDeletion {
  labelPath: string[];
  contextId: string;
  startTime: Date;
  endTime: Date;
}

export type StagedContextPayload = {
  content: ContextContent;
  deletionIds?: string[]; // If provided this list of UUIDs will be used to delete context as requested.
  extensionContexts?: StagedContext[];
  reasonCodeDeletions?: ReasonCodeDeletion[];
};

export type StagedContext = StagedContextIdentifier & StagedContextPayload;

export type LabelHierarchyInputPair = { categoryName: string; labelName: string };

export enum UserDefinedContextType {
  Toggle = 'Toggle',
  Label = 'Label',
  Numeric = 'Numeric',
  Text = 'Text',
}

export const isUserDefinedContextType = (type: string): type is UserDefinedContextType => {
  return Object.values(UserDefinedContextType).includes(type as UserDefinedContextType);
};

/**
 * Represents the type of API to call when updating context
 */
export type ContextApiType = 'comment' | 'numeric' | 'label';
